import React, { useState } from 'react';
import { toast } from 'react-toastify';
import mailFrame from '../assets/login email.png';
import lockFrame from '../assets/login password.png';
import logo1 from '../assets/new-Logo.png';
import logo from '../assets/logo PNG Transparent/Logo-08.png';
import textlogo from '../assets/UnlockYourPotential.png';
import esscoBg from '../assets/essco-bg.png';
import { Link } from 'react-router-dom';
import api from "../sever/Api"

const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        // Split name into firstName & lastName
        let firstName = name;
        let lastName = "";
        if (name.trim().includes(" ")) {
            const parts = name.trim().split(" ");
            firstName = parts[0];
            lastName = parts.slice(1).join(" ");
        } else {
            lastName = "User";
        }

        // Password check
        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters long");
            return;
        }

        try {
            const { data } = await api.post("/api/auth/signup", {
                firstName,
                lastName,
                email,
                password,
            });

            console.log("API Response:", data);

            if (data.token) {
                localStorage.setItem("token", data.token);
            }

            // Flag to show upgrade popup after first login
            try { localStorage.setItem('showUpgradeAfterSignup', '1'); } catch (_) { }
            
            // Flag to indicate this is a first-time user
            try { localStorage.setItem('isFirstTimeUser', '1'); } catch (_) { }

            toast.success("Registration successful! Please log in.");
            setTimeout(() => {
                window.location.href = "/login";
            }, 1200);

        } catch (error) {
            console.error("Error:", error);

            if (error.response) {
                if (
                    error.response.status === 400 &&
                    error.response.data.message?.includes("already exists")
                ) {
                    toast.error(
                        "This email is already registered. Please use a different email or try logging in."
                    );
                } else {
                    toast.error(error.response.data.message || "Registration failed");
                }
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    return (
        <>
            <div className=' min-h-screen bg-[linear-gradient(126.39deg,#F7F6FA_5.58%,#F5F4FC_27.79%,#F2F2FE_48.29%,#F5F4FF_69.65%,#FFF9FF_94.42%)]' style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="flex flex-row justify-center items-center px-[32px] py-[16px] bg-[rgba(247,248,250,0.01)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)]" >
                    <img src={logo1} alt="HWORK2 Logo" style={{ width: 215, height: 41 }} />
                </div>
                <div className="m-6  overflow-x-hidden flex items-center justify-center ">

                    {/* Main Register Card */}
                    <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
                        {/* Card Header */}
                        <div className="text-center mb-8">
                            <div className=" flex items-center justify-center mx-auto mb-4 relative" style={{ width: 123 }}>
                                <img src={logo} alt="HWORK2 Logo" className="w-full h-full" />
                            </div>
                            <h1 className="font-semibold text-[24px] leading-[32px] text-center text-[#151417] mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>The HWORK2 Method</h1>
                            <img src={textlogo} alt="HWORK2 Logo" className="w-full h-full" />
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6" >
                            {/* Name */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                                <input
                                    type="text"
                                    placeholder="Your name"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    required
                                    className="w-full border border-gray-300 rounded-lg px-3 py-3 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-purple-500 transition"
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-3 focus-within:border-purple-500 transition">
                                    <img src={mailFrame} alt="email" className="w-4 h-4 mr-3 text-gray-400" />
                                    <input
                                        type="email"
                                        placeholder="name@mail.com"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Password */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-3 focus-within:border-purple-500 transition">
                                    <img src={lockFrame} alt="lock" className="w-4 h-4 mr-3 text-gray-400" />
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="••••••••••"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={togglePasswordVisibility}
                                        className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-300"
                                        title={showPassword ? "Hide password" : "Show password"}
                                    >
                                        {showPassword ? (
                                            // Eye closed icon (password hidden)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                                                />
                                            </svg>
                                        ) : (
                                            
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Confirm Password */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
                                <div className="flex items-center border border-gray-300 rounded-lg px-3 py-3 focus-within:border-purple-500 transition">
                                    <img src={lockFrame} alt="lock" className="w-4 h-4 mr-3 text-gray-400" />
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        placeholder="••••••••••"
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={toggleConfirmPasswordVisibility}
                                        className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-300"
                                        title={showConfirmPassword ? "Hide password" : "Show password"}
                                    >
                                        {showConfirmPassword ? (
                                            // Eye closed icon (password hidden)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                                                />
                                            </svg>
                                        ) : (
                                            // Eye open icon (password visible)
                                            <svg
                                                className="w-5 h-5 text-gray-600"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <button
                                type="submit"
                                className="w-full py-3 rounded-lg bg-[#7A81FF] text-white font-semibold hover:from-purple-600 hover:to-purple-800"
                            >
                                Sign Up
                            </button>

                            {/* Login Link */}
                            <p className="text-center text-[18px] text-gray-600">
                                Already have an account? <Link to="/login" className="text-[#7A81FF] underline hover:text-purple-800">Sign in</Link>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Register; 